import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getPaginateNotificationList } from '../helpers/helpers';
import { getRequest, postRequest } from 'utils/requests';
import { initialTableShow } from 'utils/settings';
import {
  PageTitle,
  PaginationGroup,
  LimitPaginationButton,
  EmptyState,
  ButtonIcon,
  SelectDropDown,
  Loading
} from 'components/common/Elements/Elements';
import NotificationsTable from '../NotificationsTable/NotificationsTable';

import classes from './NotificationPage.module.scss';

const NotificationPage = () => {
  const [notifications, setNotifications] = useState('');
  const [notificationsList, setNotificationsList] = useState('');
  const [loader, setLoader] = useState(true);

  const [dataConection, setDataConection] = useState(true);
  const [currentPage, setCurrentPage] = useState(initialTableShow.currentPage);
  const [itemsPerPage, setItemsPerPage] = useState(
    initialTableShow.itemsPerPage
  );
  const [status, setStatus] = useState('All message');

  const { t } = useTranslation('activity');

  let optionStatus = [];

  useEffect(() => {
    getNotifications();
  }, []);

  useEffect(() => {
    if (notifications) {
      setNotificationsList(
        getPaginateNotificationList(
          notifications,
          status,
          currentPage,
          itemsPerPage
        )
      );
      setLoader(false);
    }

    // eslint-disable-next-line
  }, [notifications, currentPage, itemsPerPage, status]);

  const getNotifications = () => {
    getRequest('/user/notifications/list')
      .then(res => {
        setDataConection(true);
        setNotifications(res.body);
      })
      .catch(err => {
        setDataConection(false);
        console.log(err);
        setLoader(false);
      });
  };

  const handleRead = _id => {
    if (!_id) return;

    postRequest('/user/notification/markasread', {
      notifId: _id
    })
      .then(() => {
        getNotifications();
      })
      .catch(err => {
        setDataConection(false);
        console.log(err);
      });
  };

  const resetCurentPage = () => {
    setCurrentPage(1);
    setLoader(true);
  };

  const handleLimitChange = limit => {
    if (itemsPerPage === limit) {
      return;
    }
    resetCurentPage();
    setItemsPerPage(limit);
  };

  const handleStatus = e => {
    if (e === status) {
      return;
    }
    resetCurentPage();
    setStatus(e);
  };

  const handleAllRead = () => {
    getRequest('/user/notifications/markallasread')
      .then(() => {
        getNotifications();
      })
      .catch(err => {
        console.log(err);
      });
  };

  optionStatus = [
    { value: 'All message', label: 'All message' },
    { value: 'Not read message', label: 'Not read message' },
    { value: 'Read message', label: 'Read message' }
  ];

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <div className={classes.notifications}>
      <PageTitle
        title={t('activity:notification.NOTIFICATION_PAGE')}
        className={classes.title}
      />

      <div className={classes.filters_main}>
        <SelectDropDown
          clearable={false}
          className={classes.status}
          options={optionStatus}
          input={{ value: status, onChange: handleStatus }}
          label={t('activity:notification.STATUS')}
        />

        <div className={classes.filters_main__right}>
          <ButtonIcon
            icon="schedule"
            buttonText={t('activity:notification.MARK_ALL_AS_READ')}
            onClick={handleAllRead}
            marginLeftAuto={true}
          />
          <LimitPaginationButton
            currentLimit={itemsPerPage}
            onLimitChange={handleLimitChange}
          />
        </div>
      </div>
      {loader ? (
        <Loading />
      ) : (
        <>
          <NotificationsTable
            notifications={notificationsList.notifications}
            handleRead={handleRead}
          />

          {notificationsList &&
            notificationsList.size > 10 &&
            notificationsList.totalPages > 1 && (
              <PaginationGroup
                pageCount={notificationsList.totalPages}
                setPage={setCurrentPage}
                currentPage={currentPage}
                itemsTotal={notificationsList.size}
                itemsPerPage={itemsPerPage}
              />
            )}
        </>
      )}
    </div>
  );
};

export default NotificationPage;
